<div class="mb-5">

@if (loading()) {
  <p class="text-muted">Loading glide path&hellip;</p>
}
@if (error()) {
  <p class="text-muted">{{ error() }}</p>
}
<div class="gp-chart-wrap" [class.d-none]="loading() || error()">
  <div #chart class="chart-host"></div>
  <button type="button" class="gp-download-btn" (click)="downloadSvg()"
          aria-label="Download SVG" title="Download SVG">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
         fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M8 2v8m0 0 3-3m-3 3L5 7"/>
      <path d="M2.5 11.5v1a1.5 1.5 0 0 0 1.5 1.5h8a1.5 1.5 0 0 0 1.5-1.5v-1"/>
    </svg>
  </button>
</div>
@if (!loading() && !error()) {
  <div class="gp-controls mt-2">
    <div class="d-flex flex-wrap align-items-center gap-1 mb-2">
      <span class="small fw-semibold me-1">Vintages:</span>
      @for (v of vintageOptions(); track v.vintage) {
        <button type="button"
                class="btn btn-sm gp-vintage-btn"
                [class.btn-primary]="v.visible"
                [class.btn-outline-secondary]="!v.visible"
                [attr.aria-pressed]="v.visible"
                (click)="toggleVintage(v.vintage)">{{ v.label }}</button>
      }
    </div>
    <div class="d-flex flex-wrap align-items-center gap-3">
      <label class="d-flex align-items-center gap-2 small mb-0">
        Your age
        <input type="number" class="form-control form-control-sm gp-age-input"
               min="10" max="100" placeholder="—"
               [value]="userAge() ?? ''" (input)="onUserAge($event)">
      </label>
      <label class="d-flex align-items-center gap-2 small mb-0">
        Retirement age
        <input type="number" class="form-control form-control-sm gp-age-input"
               min="40" max="85"
               [value]="retireAge()" (change)="onRetireAge($event)">
      </label>
      @if (targetYear() !== null) {
        <span class="small text-muted">Retiring around {{ targetYear() }} &mdash; your closest vintage is highlighted.</span>
      }
    </div>
  </div>
}
</div>